import React from 'react';
import './SocialMedia.css';

export const SocialMedia = () => {
  return (
    <div className='social-media-div'>
      <a
        href='https://github.com/olliviermorales'
        className='icon-button github'
        target='_blank'
        rel='noopener noreferrer'
      >
        <i className='fab fa-github'></i>
        <span></span>
      </a>
      <a
        href='https://www.linkedin.com/in/ojrmorales/'
        className='icon-button linkedin'
        target='_blank'
        rel='noopener noreferrer'
      >
        <i className='fab fa-linkedin-in'></i>
        <span></span>
      </a>
      <a
        href='mailto: morales.ollivier@gmail.com'
        className='icon-button google'
        target='_blank'
        rel='noopener noreferrer'
      >
        <i className='fab fa-google'></i>
        <span></span>
      </a>
      <a
        href='https://www.facebook.com/OllivierJullesMorales'
        className='icon-button facebook'
        target='_blank'
        rel='noopener noreferrer'
      >
        <i className='fab fa-facebook-f'></i>
        <span></span>
      </a>
      <a
        href='https://www.instagram.com/ojrmorales'
        className='icon-button instagram'
        target='_blank'
        rel='noopener noreferrer'
      >
        <i className='fab fa-instagram'></i>
        <span></span>
      </a>
    </div>
  );
};

export default SocialMedia;
